import MicroFrontend from '../MicroFrontend'
import {Header} from '../shared/header/Header'
import {Footer} from '../shared/footer/Footer'
import {SideBar} from "../shared/header/SideBar";
import "./scrollable.css"

const verticalNavStyle = {
    height: "100vh"
}

export function FlowOverview({history, userPermissions}) {
    const {REACT_APP_FLOW_OVERVIEW_HOST: flowOverviewHost} = process.env
    return (
        <div>
            <div className="eds-flex" style={verticalNavStyle}>
                <div>
                    <SideBar userPermissions={userPermissions}/>
                </div>
                <div className="eds-flex--grow-1">
                    <Header isDark={true} userPermissions={userPermissions}/>
                    <div className="scrollable">
                        <MicroFrontend
                            history={history}
                            host={flowOverviewHost}
                            microFrontendUiName="FlowOverview"
                            permissions={userPermissions}/>
                        <Footer/>
                    </div>
                </div>
            </div>
        </div>
    )
}
